import _define_property from "@swc/helpers/src/_define_property.mjs";
import JSBI from "jsbi";
import { Token } from "./entities/token";
export var ChainId;
(function(ChainId) {
    ChainId[ChainId["ETHEREUM"] = 1] = "ETHEREUM";
    ChainId[ChainId["RINKEBY"] = 4] = "RINKEBY";
    ChainId[ChainId["GOERLI"] = 5] = "GOERLI";
    ChainId[ChainId["BSC"] = 56] = "BSC";
    ChainId[ChainId["BSC_TESTNET"] = 97] = "BSC_TESTNET";
    ChainId[ChainId["HARDHAT"] = 31337] = "HARDHAT";
    ChainId[ChainId["POLYGON"] = 137] = "POLYGON";
    ChainId[ChainId["MUMBAI"] = 80001] = "MUMBAI";
    ChainId[ChainId["FANTOM"] = 250] = "FANTOM";
    ChainId[ChainId["FANTOM_TESTNET"] = 4002] = "FANTOM_TESTNET";
})(ChainId || (ChainId = {}));
export var TradeType;
(function(TradeType) {
    TradeType[TradeType["EXACT_INPUT"] = 0] = "EXACT_INPUT";
    TradeType[TradeType["EXACT_OUTPUT"] = 1] = "EXACT_OUTPUT";
})(TradeType || (TradeType = {}));
export var Rounding;
(function(Rounding) {
    Rounding[Rounding["ROUND_DOWN"] = 0] = "ROUND_DOWN";
    Rounding[Rounding["ROUND_HALF_UP"] = 1] = "ROUND_HALF_UP";
    Rounding[Rounding["ROUND_UP"] = 2] = "ROUND_UP";
})(Rounding || (Rounding = {}));
export var FACTORY_ADDRESS = "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73";
var FACTORY_ADDRESS_ETH = "0x1097053Fd2ea711dad45caCcc45EfF7548fCB362";
var _obj;
export var FACTORY_ADDRESS_MAP = (_obj = {}, _define_property(_obj, ChainId.ETHEREUM, FACTORY_ADDRESS_ETH), _define_property(_obj, ChainId.RINKEBY, FACTORY_ADDRESS_ETH), _define_property(_obj, ChainId.GOERLI, FACTORY_ADDRESS_ETH), _define_property(_obj, ChainId.BSC, FACTORY_ADDRESS), _define_property(_obj, ChainId.FANTOM, FACTORY_ADDRESS), _define_property(_obj, ChainId.BSC_TESTNET, "0x6725f303b657a9451d8ba641348b6761a6cc7a17"), _define_property(_obj, ChainId.POLYGON, "0x6725f303b657a9451d8ba641348b6761a6cc7a17"), _define_property(_obj, ChainId.MUMBAI, "0x6725f303b657a9451d8ba641348b6761a6cc7a17"), _define_property(_obj, ChainId.FANTOM_TESTNET, "0x6725f303b657a9451d8ba641348b6761a6cc7a17"), _obj);
export var INIT_CODE_HASH = "0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5";
var INIT_CODE_HASH_ETH = "0x57224589c67f3f30a6b0d7a1b54cf3153ab84563bc609ef41dfb34f8b2974d2d";
var _obj1;
export var INIT_CODE_HASH_MAP = (_obj1 = {}, _define_property(_obj1, ChainId.ETHEREUM, INIT_CODE_HASH_ETH), _define_property(_obj1, ChainId.RINKEBY, INIT_CODE_HASH_ETH), _define_property(_obj1, ChainId.GOERLI, INIT_CODE_HASH_ETH), _define_property(_obj1, ChainId.BSC, INIT_CODE_HASH), _define_property(_obj1, ChainId.FANTOM, INIT_CODE_HASH), _define_property(_obj1, ChainId.BSC_TESTNET, "0xd0d4c4cd0848c93cb4fd1f498d7013ee6bfb25783ea21593d5834f5d250ece66"), _define_property(_obj1, ChainId.POLYGON, "0xd0d4c4cd0848c93cb4fd1f498d7013ee6bfb25783ea21593d5834f5d250ece66"), _define_property(_obj1, ChainId.MUMBAI, "0xd0d4c4cd0848c93cb4fd1f498d7013ee6bfb25783ea21593d5834f5d250ece66"), _define_property(_obj1, ChainId.FANTOM_TESTNET, "0xd0d4c4cd0848c93cb4fd1f498d7013ee6bfb25783ea21593d5834f5d250ece66"), _obj1);
export var MINIMUM_LIQUIDITY = JSBI.BigInt(1000);
// exports for internal consumption
export var ZERO = JSBI.BigInt(0);
export var ONE = JSBI.BigInt(1);
export var TWO = JSBI.BigInt(2);
export var THREE = JSBI.BigInt(3);
export var FIVE = JSBI.BigInt(5);
export var TEN = JSBI.BigInt(10);
export var _100 = JSBI.BigInt(100);
export var _9975 = JSBI.BigInt(9975);
export var _10000 = JSBI.BigInt(10000);
export var MaxUint256 = JSBI.BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff");
export var SolidityType;
(function(SolidityType) {
    SolidityType["uint8"] = "uint8";
    SolidityType["uint256"] = "uint256";
})(SolidityType || (SolidityType = {}));
var _obj2;
export var SOLIDITY_TYPE_MAXIMA = (_obj2 = {}, _define_property(_obj2, SolidityType.uint8, JSBI.BigInt("0xff")), _define_property(_obj2, SolidityType.uint256, JSBI.BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff")), _obj2);
var _obj3;
export var WETH9 = (_obj3 = {}, _define_property(_obj3, ChainId.ETHEREUM, new Token(ChainId.ETHEREUM, "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2", 18, "WETH", "Wrapped Ether", "https://weth.io")), _define_property(_obj3, ChainId.RINKEBY, new Token(ChainId.RINKEBY, "0xc778417E063141139Fce010982780140Aa0cD5Ab", 18, "WETH", "Wrapped Ether", "https://weth.io")), _define_property(_obj3, ChainId.GOERLI, new Token(ChainId.GOERLI, "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6", 18, "WETH", "Wrapped Ether", "https://weth.io")), _obj3);
var _obj4;
export var WBNB = (_obj4 = {}, _define_property(_obj4, ChainId.ETHEREUM, new Token(ChainId.ETHEREUM, "0x418D75f65a02b3D53B2418FB8E1fe493759c7605", 18, "WBNB", "Wrapped BNB", "https://www.binance.org")), _define_property(_obj4, ChainId.BSC, new Token(ChainId.BSC, "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c", 18, "WBNB", "Wrapped BNB", "https://www.binance.org")), _define_property(_obj4, ChainId.BSC_TESTNET, new Token(ChainId.BSC_TESTNET, "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd", 18, "WBNB", "Wrapped BNB", "https://www.binance.org")), _define_property(_obj4, ChainId.HARDHAT, new Token(ChainId.HARDHAT, "0xae13d989daC2f0dEbFf460aC112a837C89BAa7cd", 18, "WBNB", "Wrapped BNB", "https://www.binance.org")), _obj4);
var _obj5;
export var WMATIC = (_obj5 = {}, _define_property(_obj5, ChainId.POLYGON, new Token(ChainId.POLYGON, "0x418D75f65a02b3D53B2418FB8E1fe493759c7605", 18, "WMATIC", "Wrapped MATIC", "https://polygon.technology/")), _define_property(_obj5, ChainId.MUMBAI, new Token(ChainId.POLYGON, "0x418D75f65a02b3D53B2418FB8E1fe493759c7605", 18, "WMATIC", "Wrapped MATIC", "https://polygon.technology/")), _obj5);
var _obj6;
export var WFANTOM = (_obj6 = {}, _define_property(_obj6, ChainId.FANTOM, new Token(ChainId.FANTOM, "0x418D75f65a02b3D53B2418FB8E1fe493759c7605", 18, "WFANTOM", "Wrapped FANTOM", "https://fantom.foundation/")), _define_property(_obj6, ChainId.FANTOM_TESTNET, new Token(ChainId.FANTOM, "0x418D75f65a02b3D53B2418FB8E1fe493759c7605", 18, "WMATIC", "Wrapped FANTOM", "https://fantom.foundation/")), _obj6);
var _obj7;
export var WNATIVE = (_obj7 = {}, _define_property(_obj7, ChainId.ETHEREUM, WETH9[ChainId.ETHEREUM]), _define_property(_obj7, ChainId.RINKEBY, WETH9[ChainId.RINKEBY]), _define_property(_obj7, ChainId.GOERLI, WETH9[ChainId.GOERLI]), _define_property(_obj7, ChainId.BSC, WBNB[ChainId.BSC]), _define_property(_obj7, ChainId.FANTOM, WFANTOM[ChainId.FANTOM]), _define_property(_obj7, ChainId.BSC_TESTNET, WBNB[ChainId.BSC_TESTNET]), _define_property(_obj7, ChainId.HARDHAT, WBNB[ChainId.HARDHAT]), _define_property(_obj7, ChainId.POLYGON, WMATIC[ChainId.POLYGON]), _define_property(_obj7, ChainId.MUMBAI, WMATIC[ChainId.MUMBAI]), _define_property(_obj7, ChainId.FANTOM_TESTNET, WFANTOM[ChainId.FANTOM]), _obj7);
var _obj8;
export var NATIVE = (_obj8 = {}, _define_property(_obj8, ChainId.ETHEREUM, {
    name: "Ether",
    symbol: "ETH",
    decimals: 18
}), _define_property(_obj8, ChainId.RINKEBY, {
    name: "Rinkeby Ether",
    symbol: "RIN",
    decimals: 18
}), _define_property(_obj8, ChainId.GOERLI, {
    name: "Goerli Ether",
    symbol: "GOR",
    decimals: 18
}), _define_property(_obj8, ChainId.BSC, {
    name: "Binance Chain Native Token",
    symbol: "BNB",
    decimals: 18
}), _define_property(_obj8, ChainId.BSC_TESTNET, {
    name: "Binance Chain Native Token",
    symbol: "TBNB",
    decimals: 18
}), _define_property(_obj8, ChainId.HARDHAT, {
    name: "Hardhat Chain Native Token",
    symbol: "TETH",
    decimals: 18
}), _define_property(_obj8, ChainId.POLYGON, {
    name: "Matic Chain Native Token",
    symbol: "MATIC",
    decimals: 18
}), _define_property(_obj8, ChainId.MUMBAI, {
    name: "Matic Chain Native Token",
    symbol: "TMATIC",
    decimals: 18
}), _define_property(_obj8, ChainId.FANTOM, {
    name: "Fantom Native Token",
    symbol: "FTM",
    decimals: 18
}), _define_property(_obj8, ChainId.FANTOM_TESTNET, {
    name: "Fantom Chain Native Token",
    symbol: "TFTM",
    decimals: 18
}), _obj8);
